module.exports = __webpack_public_path__ + "img/ac2_thumb.ab38fc4c.jpg";